export const hasOnlyFreeOptionChoices = (options: Object[]) =>
  options.every(option => {
    const price = typeof option?.price === 'number' ? option.price : 1;
    const taxIncludedAmount = typeof option?.price?.taxIncludedAmount === 'number' ? option.price.taxIncludedAmount : 1;
    return price === 0 || taxIncludedAmount === 0;
  });
